module.exports = __webpack_public_path__ + "media/Video 115.96817a5e.mp4";